const DesktopIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={89.3}
    height={59.533}
    {...props}
  >
    <path
      fill="currentColor"
      d="M74.417 52.092a7.432 7.432 0 0 0 7.4-7.442l.037-37.208A7.464 7.464 0 0 0 74.417 0H14.883a7.464 7.464 0 0 0-7.442 7.442V44.65a7.464 7.464 0 0 0 7.442 7.442H0v7.442h89.3v-7.442ZM14.883 7.442h59.534V44.65H14.883Z"
      data-name="Icon material-computer"
    />
  </svg>
);
export default DesktopIcon;
